import { useMemo, useState } from "react";

export const usePagination = (items = [], initialPageSize = 10) => {
  const [pageState, setPageState] = useState({ page: 1, totalItems: items.length });
  const [pageSize, setPageSize] = useState(initialPageSize);
  const totalItems = items.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const requestedPage = pageState.totalItems === totalItems ? pageState.page : 1;
  const currentPage = Math.min(requestedPage, totalPages);
  const paginatedItems = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, currentPage, pageSize]);

  return {
    page: currentPage,
    pageSize,
    totalItems,
    totalPages,
    paginatedItems,
    setPage: (nextPage) => setPageState({
      page: Math.min(Math.max(Number(nextPage) || 1, 1), totalPages),
      totalItems,
    }),
    setPageSize: (nextSize) => {
      setPageSize(Number(nextSize) || initialPageSize);
      setPageState({ page: 1, totalItems });
    },
  };
};

export const useServerPagination = (initialPageSize = 10) => {
  const [state, setState] = useState({
    page: 1,
    pageSize: initialPageSize,
    totalItems: 0,
    totalPages: 1,
  });

  return {
    ...state,
    setPage: (page) => setState((current) => ({
      ...current,
      page: Math.min(Math.max(Number(page) || 1, 1), current.totalPages),
    })),
    setPageSize: (pageSize) => setState((current) => ({
      ...current,
      page: 1,
      pageSize: Number(pageSize) || initialPageSize,
    })),
    resetPage: () => setState((current) => ({ ...current, page: 1 })),
    applyResponse: (data) => setState((current) => {
      const totalPages = Math.max(Number(data?.totalPages || 1), 1);
      return {
        ...current,
        page: Math.min(Number(data?.page || current.page), totalPages),
        pageSize: Number(data?.limit || current.pageSize),
        totalItems: Number(data?.total || 0),
        totalPages,
      };
    }),
  };
};
